var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBtnLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_666_36722)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.958 9.54992C22.958 9.54992 22.958 9.55756 22.958 9.56138L18.8009 24.2188C18.7379 24.4568 18.6084 24.6686 18.4297 24.8257C18.2509 24.9828 18.0315 25.0777 17.8009 25.0977C17.768 25.1008 17.7352 25.1023 17.7023 25.1023C17.4861 25.103 17.2743 25.0376 17.0918 24.9138C16.9093 24.79 16.7637 24.6129 16.6723 24.4036L14.1216 18.6464C14.0964 18.5895 14.0883 18.5256 14.0984 18.4635C14.1085 18.4015 14.1363 18.3443 14.178 18.2998L18.268 13.9264C18.3707 13.8109 18.427 13.6571 18.4251 13.4978C18.4232 13.3385 18.3632 13.1863 18.2578 13.0736C18.1524 12.9609 18.0101 12.8968 17.8611 12.8947C17.712 12.8927 17.5682 12.9529 17.4602 13.0627L13.3637 17.4353C13.3221 17.4799 13.2686 17.5096 13.2105 17.5204C13.1525 17.5312 13.0927 17.5226 13.0394 17.4956L7.68226 14.7824C7.47187 14.6794 7.2948 14.5119 7.1735 14.3012C7.05219 14.0905 6.9921 13.846 7.00083 13.5988C7.01247 13.3446 7.09852 13.1009 7.24682 12.9019C7.39512 12.7029 7.59817 12.5588 7.82726 12.4899L21.5373 8.04554H21.548C21.7432 7.98691 21.9495 7.98486 22.1457 8.03959C22.3419 8.09432 22.5209 8.20387 22.6644 8.35699C22.808 8.51011 22.9108 8.7013 22.9624 8.91094C23.014 9.12057 23.0125 9.34111 22.958 9.54992Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_36722",
    x1: 0,
    y1: 16,
    x2: 32,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4248E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#4248E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C9C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBtnLight);
export default __webpack_public_path__ + "static/media/sendBtnLight.9c9f691d68eea802e804f3d0dd318d12.svg";
export { ForwardRef as ReactComponent };